import CloseIcon from '@mui/icons-material/Close';
import EditIcon from '@mui/icons-material/Edit';
import {
  Box,
  Dialog,
  DialogContent,
  Divider,
  IconButton,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Tooltip,
  Typography,
} from '@mui/material';
import numeral from 'numeral';
import { useState } from 'react';
import UpdateWinnerModal from './update-winner-modal';

type WinnersModalProps = {
  open: boolean;
  onClose: () => void;
  raffle: any;
  winners: any[];
};

const WinnersModal = ({ open, onClose, raffle, winners }: WinnersModalProps) => {
  const [selectedWinner, setSelectedWinner] = useState<any>(null);

  return (
    <>
      <Dialog
        open={open}
        onClose={onClose}
        maxWidth="md"
        fullWidth
        PaperProps={{ sx: { borderRadius: 3, p: 1 } }}
      >
        <DialogContent sx={{ position: 'relative', px: 3, pt: 3, pb: 2 }}>
          <IconButton
            onClick={onClose}
            size="small"
            sx={{ position: 'absolute', top: 12, right: 12, color: '#9CA3AF' }}
          >
            <CloseIcon fontSize="small" />
          </IconButton>

          {/* Header info */}
          <Box mb={1}>
            <Typography fontSize={16} fontWeight={700} color="#111827">
              Draw Title:{' '}
              <Typography component="span" fontSize={16} fontWeight={700} color="#718EBF">
                {raffle?.description ?? '-'}
              </Typography>
            </Typography>
          </Box>
          <Box mb={2}>
            <Typography fontSize={16} fontWeight={700} color="#111827">
              Draw No.:{' '}
              <Typography component="span" fontSize={16} fontWeight={700} color="#718EBF">
                {raffle?.code ?? '-'}
              </Typography>
            </Typography>
          </Box>

          <Divider sx={{ mb: 2 }} />

          {/* Table */}
          <Table size="small">
            <TableHead>
              <TableRow>
                {['Place', 'User ID', 'Display Name', 'Player Entries', 'Update'].map((h) => (
                  <TableCell
                    key={h}
                    align={h === 'Update' || h === 'Player Entries' ? 'center' : 'left'}
                    sx={{ fontSize: 13, fontWeight: 600, color: '#718EBF', borderBottom: '1px solid #F3F4F6' }}
                  >
                    {h}
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody>
              {winners.length === 0 ? (
                <TableRow>
                  <TableCell colSpan={5} align="center" sx={{ py: 4, color: '#9CA3AF', fontSize: 13 }}>
                    No winners found
                  </TableCell>
                </TableRow>
              ) : (
                winners.map((winner: any, i: number) => (
                  <TableRow key={i} hover>
                    <TableCell sx={{ fontSize: 13, fontWeight: 700, color: '#718EBF' }}>
                      {winner.place ?? i + 1}
                    </TableCell>
                    <TableCell sx={{ fontSize: 13 }}>{winner.user?.id ?? '-'}</TableCell>
                    <TableCell sx={{ fontSize: 13 }}>{winner.user?.displayName ?? '-'}</TableCell>
                    <TableCell align="center" sx={{ fontSize: 13 }}>
                      {numeral(winner.totalRedeemedTickets).format('0,000')}
                    </TableCell>
                    <TableCell align="center">
                      <Tooltip title="Update Winner" arrow>
                        <IconButton
                          size="small"
                          onClick={() => setSelectedWinner(winner)}
                          sx={{
                            bgcolor: '#4F5BA6',
                            color: 'white',
                            borderRadius: '6px',
                            width: 32,
                            height: 32,
                            '&:hover': { bgcolor: '#3a4590' },
                          }}
                        >
                          <EditIcon sx={{ fontSize: 16 }} />
                        </IconButton>
                      </Tooltip>
                    </TableCell>
                  </TableRow>
                ))
              )}
            </TableBody>
          </Table>
        </DialogContent>
      </Dialog>

      <UpdateWinnerModal
        open={!!selectedWinner}
        onClose={() => setSelectedWinner(null)}
        winner={selectedWinner}
        raffle={raffle}
        onSuccess={() => setSelectedWinner(null)}
      />
    </>
  );
};

export default WinnersModal;
